import styled from '@emotion/styled';

const LogoLink = styled.a`
  display: inline-flex;
  align-items: center;
  text-decoration: none;
`;

const LogoImg = styled.img<{ height: number }>`
  height: ${({ height }) => height}px;
  width: auto;
  display: block;
`;

interface LogoProps {
  href?: string;
  height?: number;
}

export default function Logo({ href = '/', height = 26 }: LogoProps) {
  return (
    <LogoLink href={href}>
      <LogoImg src="/logo/pixels-logo-full-ondark.png" alt="Pixels" height={height} />
    </LogoLink>
  );
}
